import { TruckIcon } from '@heroicons/react/24/outline';

export default function ActiveMoveShareLink({ url, expiresAt }: { url?: string; expiresAt?: string }) {
  if (!url || !expiresAt || !(Date.parse(expiresAt) > Date.now())) return null;
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:' || parsed.hostname !== 'cloud.samsara.com'
      || parsed.username || parsed.password || !parsed.pathname.includes('/fleet/viewer/')) return null;
  } catch { return null; }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      title="Open active move live location in Samsara (new tab)"
      aria-label="Open active move live location in Samsara"
      className="inline-flex rounded p-1 text-blue-600 hover:bg-blue-50 hover:text-blue-800 focus-visible:outline focus-visible:outline-2 dark:text-blue-400 dark:hover:bg-gray-800">
      <TruckIcon className="h-5 w-5" />
    </a>
  );
}
